import { timestampsMap } from "./timestamps";

export const allergiesMap: GenericObject = {
	paciente_id: "patientId",
	tipo: "type",
	descricao: "description",
	...timestampsMap,
};
